import React from 'react';
import { Flex, Text } from 'rebass';
import ToggleGroupField from '@/components/ToggleGroupField';
import type { MfaMethod } from '@ecosconnect/core/src/auth/types';

type TwoFactorMethodPickerProps = {
  value: MfaMethod;
  hasPhone: boolean;
  disabled?: boolean;
  align: 'flex-start' | 'flex-end';
  onChange: (method: MfaMethod) => void;
};

const TwoFactorMethodPicker: React.FC<TwoFactorMethodPickerProps> = ({
  value,
  hasPhone,
  disabled,
  align,
  onChange,
}) => (
  <Flex flexDirection="column" alignItems={align} sx={{ gap: 1 }}>
    <ToggleGroupField<MfaMethod>
      options={[
        { value: 'sms', label: 'Text', disabled: !hasPhone },
        { value: 'email', label: 'Email' },
      ]}
      value={value}
      disabled={disabled}
      onValueChange={onChange}
    />
    {!hasPhone && (
      <Text variant="body2" color="fieldBorderHover">
        Add a mobile phone in My Account
      </Text>
    )}
  </Flex>
);

export default TwoFactorMethodPicker;
